<template>
  <right-menu-item
    @click.prevent="click"
    :class="{ 'muted': !show }"
    :text="bcSelectedStore.listSelected.length > 1 ? $t('Cancel shares') : $t('Cancel share')"
    :loading="loading"
    icon="close"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'
import { ShareApi } from '../../test-api/index.ts'
import {showConfirm} from "../BcConfirm";
import { trackEvent } from '../../gtm'
import handleApiError from '../../utils/handleApiError'

const shareApi = new ShareApi({}, '/api/v2')

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      return this.bcSelectedStore.list.length > 0
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    async click () {
      const realyCancel = await showConfirm({
        header: this.$t('Do you realy want to cancel selected shares?'),
      })

      if (!realyCancel) {
        return
      }

      this.loading = true
      await handleApiError(() => shareApi.shareCancelShare({
        ids: this.bcSelectedStore.list.map(item => parseInt(item.id))
      }))
      // reload table?
      await NetteAjax.ajax(this.$controls.table.refresh)
      this.bcSelectedStore.reset(null, 'id', null, false)
      this.loading = false

      trackEvent(this.$route.matched[0].name, 'cancelShare')
    }
  },
}
</script>

<style lang="scss" scoped></style>
